// явяляется ли url ссылкой на картинку, которую загрузил пользователь
import { IMG_PIXEL } from '~/configs/images'
import { useImageResizer } from '~/utils/imageResizer'

export function isUserImage (url) {
  return [
    process.env.IMG_HOST,
    process.env.IMG_HOST_FALLBACK,
    process.env.FILES_UPLOAD_HOST,
    process.env.FILES_UPLOAD_HOST_FALLBACK
  ].some(i => !!i && url.includes(i))
}

/**
 * Получение ширины и высоты изображения
 * @param file - файл изображения
 */
export function getImageDimensions (file: File): Promise<{
  width: number
  height: number
}> {
  const _URL = window.URL || window.webkitURL
  return new Promise(resolve => {
    try {
      const img = new Image()
      img.onload = () => {
        resolve({
          width: img.width,
          height: img.height
        })
      }
      img.src = _URL.createObjectURL(file)
    } catch (e) {
      resolve({ width: 0, height: 0 })
    }
  })
}

/**
 * Предварительная загрузка изображения в кэш браузера
 * @param src - полный путь к изображению
 */
export function preloadImage (src: string): Promise<any> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = resolve
    img.onerror = reject
    img.src = src
  })
}

/**
 * Получение объекта изображения
 * @param src - полный путь к изображению
 */
export function getImageByUrl (src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = src
  })
}

export function getImage (file: File): Promise<any> {
  return new Promise((resolve, reject) => {
    const fReader = new FileReader()

    fReader.onload = (e) => {
      console.log('[getImage] FileReader onload, result length:', (e?.target?.result as string)?.length || 0)
      resolve(e?.target?.result)
    }

    fReader.onerror = (e) => {
      console.error('[getImage] FileReader error:', e)
      reject(new Error('FileReader failed'))
    }

    console.log('[getImage] Starting readAsDataURL for file:', file.name, file.size)
    fReader.readAsDataURL(file)
  })
}

export function getResized (url, width, height = '-'): string {
  return useImageResizer().getResized({ url, width, height })
}

export function placeholderSrc ({ width, height }: {
  width?: number | string
  height?: number | string
  color?: string
}): string {
  if (width && height) {
    return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 ${width} ${height}'%3E%3C/svg%3E`
  }

  return IMG_PIXEL
}
